<template>
    <div class="sku-info-table">
      <el-table :data="localSkuInfo" border style="width: 100%">
        <el-table-column label="售卖规格" prop="spec" min-width="180">
          <template slot-scope="scope">
            <!-- <span>{{ scope.row.spec }}</span> -->
            <el-input disabled v-model="scope.row.spec"></el-input>
          </template>
        </el-table-column>
  
        <el-table-column label="条形码" prop="upc" min-width="150">
          <template slot-scope="scope">
            <el-input disabled v-model="scope.row.upc"></el-input>
          </template>
        </el-table-column>
  
        <el-table-column label="价格" prop="price" width="150">
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.price"
              :min="0.01"
              :max="9999.99"
              :precision="2"
              :step="0.1"
              size="small"
              @change="handlePriceChange($event, scope.$index)"
            />
          </template>
        </el-table-column>
  
        <el-table-column label="库存" prop="stock" width="150">
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.stock"
              :min="0"
              :max="99999"
              :precision="0"
              size="small"
              @change="handleStockChange($event, scope.$index)"
            />
          </template>
        </el-table-column>
      </el-table>
    </div>
  </template>
  
  <script>
  export default {
    name: 'SKUInfoTable',
    model: {
      prop: 'value',
      event: 'change'
    },
    props: {
      value: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        localSkuInfo: []
      }
    },
    watch: {
      value: {
        handler(val) {
          this.localSkuInfo = JSON.parse(JSON.stringify(val));
        },
        immediate: true,
        deep: true
      }
    },
    methods: {
      handlePriceChange(value, index) {
        const newData = [...this.localSkuInfo];
        newData[index].price = value.toString();
        this.$emit('change', newData);
      },
      handleStockChange(value, index) {
        const newData = [...this.localSkuInfo];
        newData[index].stock = value;
        this.$emit('change', newData);
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .sku-info-table {
    .el-input-number {
      width: 120px;
    }
    :deep(.el-table) {
        .cell {
        padding: 8px 16px;
        }
    }
    ::v-deep .el-table__body tr td{
      padding: 8px;
    }
  }
  </style>